import React from 'react';

import sharpCatLogo from '../../assets/img/sharp-cat-logo.png';
import geolistLogo from '../../assets/img/geolist-logo.png';
import packageInfo from '../../../package.json';

function SimpleLayout(props) {

    return (
        <>
            <div className="position-relative overflow-hidden radial-gradient min-vh-100 d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center w-100">
                    <div className="row justify-content-center w-100">
                        <div className="col-md-8 col-lg-6 col-xxl-3">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <a href="https://www.sharpcat.co.uk/" target="_blank" className="text-nowrap logo-img text-center d-block mb-5 w-100">
                                        <img src={sharpCatLogo} height="90" alt="logo" />
                                    </a>
                                    {props.children}
                                </div>
                                <div className="card-footer d-flex align-items-end justify-content-between bg-white">
                                    <img src={geolistLogo} height="50" alt="logo" />
                                    <div className="fs-2 fw-bold">v{packageInfo.version}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SimpleLayout;
